import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap, map, catchError, of, switchMap } from 'rxjs';
import * as potentialConsequenceActions from '../actions/potential-consequence.actions';
import { PotentialConsequenceService } from '../../services/potential-consequence.service';
import { PotentialConsequence } from '../../models/potential-consequence.model';

@Injectable()
export class PotentialConsequenceEffects {
  constructor(
    private actions$: Actions,
    private potentialConsequenceService: PotentialConsequenceService
  ) {}

  // // Load potential Consequences
  loadPotentialConsequence$ = createEffect(() =>
    this.actions$.pipe(
      ofType(potentialConsequenceActions.loadPotentialConsequences),
      mergeMap(({ ruleUid }) => {
        return this.potentialConsequenceService.GetByRuleUid(ruleUid).pipe(
          map((potentialConsequences: PotentialConsequence[]) => {
            return potentialConsequenceActions.loadPotentialConsequencesSuccess(
              {
                potentialConsequences,
              }
            );
          }),
          catchError((error) => {
            return of(
              potentialConsequenceActions.loadPotentialConsequencesFailure({
                error,
              })
            );
          })
        );
      })
    )
  );

  deleteMultiplePotentialConsequences$ = createEffect(() =>
    this.actions$.pipe(
      ofType(potentialConsequenceActions.deleteMultiplePotentialConsequences),
      mergeMap(({ uids }) => {
        return this.potentialConsequenceService
          .DeleteMultiplePotentialConsequences(uids)
          .pipe(
            map(() =>
              potentialConsequenceActions.deleteMultiplePotentialConsequencesSuccess(
                {
                  uids,
                }
              )
            ),
            catchError((error) =>
              of(
                potentialConsequenceActions.deleteMultiplePotentialConsequencesFailure(
                  {
                    error,
                  }
                )
              )
            )
          );
      })
    )
  );

  // // Create multiple potential Consequences
  createMultiplePotentialConsequences$ = createEffect(() =>
    this.actions$.pipe(
      ofType(potentialConsequenceActions.createMultiplePotentialConsequences),
      mergeMap(({ requests }) => {
        return this.potentialConsequenceService
          .CreateMultiplePotentialConsequences(requests)
          .pipe(
            map((potentialConsequences) => {
              return potentialConsequenceActions.createMultiplePotentialConsequencesSuccess(
                {
                  potentialConsequences,
                }
              );
            }),
            catchError((error) =>
              of(
                potentialConsequenceActions.createMultiplePotentialConsequencesFailure(
                  {
                    error,
                  }
                )
              )
            )
          );
      })
    )
  );

  // // Update multiple potential Consequences
  updateMultiplePotentialConsequences$ = createEffect(() =>
    this.actions$.pipe(
      ofType(potentialConsequenceActions.updateMultiplePotentialConsequences),
      mergeMap(({ requests }) => {
        return this.potentialConsequenceService
          .UpdateMultiplePotentialConsequences(requests)
          .pipe(
            map((potentialConsequences) =>
              potentialConsequenceActions.updateMultiplePotentialConsequencesSuccess(
                {
                  potentialConsequences,
                }
              )
            ),
            catchError((error) =>
              of(
                potentialConsequenceActions.updateMultiplePotentialConsequencesFailure(
                  {
                    error,
                  }
                )
              )
            )
          );
      })
    )
  );
}
